import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=52fbd8dc&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=ts"
export * from "./ProjectsList.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=52fbd8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbd8dc",
  null
  
)

export default component.exports